export default "/images/vendor/flag-icon-css/flags/1x1/ie.svg?9e3414e898f1a07d0bea10fed8d85084";